export default (function (g, e, n, es, onError, ys) {
  g["_genesysJs"] = e;
  g[e] =
    g[e] ||
    function () {
      (g[e].q = g[e].q || []).push(arguments);
    };
  g[e].t = 1 * new Date();
  g[e].c = es;
  ys = document.createElement("script");
  ys.async = 1;
  ys.src = n;
  ys.charset = "utf-8";
  // Surface a failed script load (offline, CSP, blocked domains, ...) so the
  // app can show an error state instead of silently never becoming ready.
  if (typeof onError === "function") ys.onerror = onError;
  document.head.appendChild(ys);
});
